module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-ts-config/gatsby-browser.js'),
      options: {"plugins":[],"configDir":"/codebuild/output/src1361162438/src/phx-global-form-gatsby/src/gatsby","projectRoot":"/codebuild/output/src1361162438/src/phx-global-form-gatsby","babel":false,"tsNode":true},
    }]
